import React, { useState } from "react";
import PropTypes from "prop-types";
import submit from "submit-form";
import { useHorizontalScroll } from "../../../hooks/useHorizontalScroll";
import { PhaseTemplateCard } from "./parts/PhaseTemplateCard";
import Modal from "../../modal-new";

export const PhaseTemplatesModal = (
  { athleteId, organizationCoachId },
  { locals }
) => {
  const {
    phasesTemplates: { defaultTemplate = undefined, templates = [] },
    athlete,
  } = locals;

  const { phaseTemplateId: athleteTemplateId, phases = [] } =
    athlete.annualPlan?.trainingPhases || [];

  const defaultTemplateObject = templates.find(
    (template) => template._id === defaultTemplate
  );

  const currentCriteria =
    athleteTemplateId || (!phases.length && defaultTemplate);

  const currentPhaseTemplateIndex = templates.findIndex(
    (phase) => phase._id === currentCriteria
  );

  const [selectedPhaseIndex, setSelectedPhaseIndex] = useState(
    currentPhaseTemplateIndex
  );
  const [saveDefaultTemplate, setSaveDefaultTemplate] = useState(false);

  const [warnedState, setWarnedState] = useState(false);

  const elRef = useHorizontalScroll("faster");

  const openAddPhaseTemplateModal = () => {
    submit("/actions/refresh", {
      method: "GET",
      body: { "modal[type]": "add-phase-template" },
    });
  };

  const openRemoveDefaultTemplateModal = () => {
    submit("/actions/refresh", {
      method: "GET",
      body: {
        "modal[type]": "remove-default-template",
        defaultTemplateName: defaultTemplateObject.templateName,
        defaultTemplateId: defaultTemplateObject._id,
      },
    });
  };

  const setAthletePhasesTemplate = () => {
    if (
      templates[selectedPhaseIndex] &&
      templates[selectedPhaseIndex]._id === currentCriteria
    ) {
      if (saveDefaultTemplate) {
        let body = {
          phaseTemplate: templates[selectedPhaseIndex],
          athleteId,
          saveDefaultTemplate,
          onlySetDefault: true,
        };

        if (organizationCoachId) {
          body = { ...body, organizationCoachId };
        }

        return submit("/actions/annual-planner/set-athlete-phases", {
          method: "POST",
          body,
        });
      }
      return submit("/actions/refresh", {
        method: "GET",
        body: { "modal[type]": "" },
      });
    } else if (warnedState || !phases.length) {
      let body = {
        phaseTemplate: templates[selectedPhaseIndex],
        athleteId,
        saveDefaultTemplate,
      };

      if (organizationCoachId) {
        body = { ...body, organizationCoachId };
      }

      submit("/actions/annual-planner/set-athlete-phases", {
        method: "POST",
        body,
      });
    } else {
      setWarnedState(true);
    }
  };

  return (
    <Modal
      className={`annual-planner-modal phase-templates-modal${
        warnedState ? " warning" : ""
      }`}
      title={"Phase Template"}
    >
      <div className="body">
        {warnedState ? (
          <div>
            <span className="chip warning">
              Warning. You already have a phase template set to this athlete. By
              changing it you will remove all the dates attached to those
              phases.
            </span>

            <span>Are you sure you want to continue?</span>
          </div>
        ) : (
          <div className="phase-templates" ref={elRef}>
            {templates.map((template, index) => {
              return (
                <PhaseTemplateCard
                  key={`temps-phase-card-${index}`}
                  template={template}
                  index={index}
                  selectedPhaseIndex={selectedPhaseIndex}
                  setSelectedPhaseIndex={setSelectedPhaseIndex}
                />
              );
            })}
          </div>
        )}
      </div>
      {warnedState ? (
        <footer className="footer warning">
          <button
            role="button"
            data-action="cancel"
            onClick={() => setWarnedState(false)}
          >
            Cancel
          </button>
          <button
            role="button"
            data-button-type="primary"
            className="button-input alt-remove"
            onClick={setAthletePhasesTemplate}
          >
            Continue
          </button>
        </footer>
      ) : (
        <footer className="footer">
          <div className="footer-left">
            <button
              role="button"
              data-button-type="outline"
              onClick={openAddPhaseTemplateModal}
            >
              Add New Template
            </button>
            <div
              className="set-as-default-wrapper"
              onClick={() => setSaveDefaultTemplate(!saveDefaultTemplate)}
            >
              <div
                className={`set-as-default-checkbox${
                  saveDefaultTemplate ? " checked" : ""
                }`}
              >
                {saveDefaultTemplate && <img src="/img/svg/check.svg" />}
              </div>
              <label>Set as default</label>
            </div>
            {defaultTemplate && (
              <div className="show-default-wrapper">
                <img
                  src="/img/new-icons/red-trash.svg"
                  className="icon-remove-default"
                  onClick={openRemoveDefaultTemplateModal}
                />
                <label>
                  {defaultTemplateObject.templateName}{" "}
                  <span style={{ color: "var(--white-20)" }}>| default</span>
                </label>
              </div>
            )}
          </div>
          <div className="footer-right">
            <button
              disabled={typeof selectedPhaseIndex !== "number"}
              onClick={setAthletePhasesTemplate}
              role="button"
              data-button-type="primary"
            >
              Save
            </button>
          </div>
        </footer>
      )}
    </Modal>
  );
};

PhaseTemplatesModal.contextTypes = { locals: PropTypes.object };
